var exports = {
  "AQ": "menuButton__IIeMln",
  "Kp": "buttonName__WRO_KY",
  "sV": "menuHeading__0H0mqy",
};

module.exports = exports;
